import * as lazyIndex from './lazyIndex';
import React, { lazy, Suspense } from 'react';
import { CharmControlProps } from './schema/CharmControl.types';
import { CharmProps } from './schema/Charm.types';
import { CharmSelectorProps } from './schema/CharmSelector.types';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    System.import<typeof lazyIndex>(
        /* webpackChunkName: "Charms", webpackPrefetch: true */ './lazyIndex'
    )
);

const LazyCharmSelector = lazy(
    () =>
        import(/* webpackChunkName: "Charms", webpackPrefetch: true */ './components/CharmSelector')
);
const LazyCharmControl = lazy(
    () =>
        import(/* webpackChunkName: "Charms", webpackPrefetch: true */ './components/CharmControl')
);
const LazyCharm = lazy(
    () => import(/* webpackChunkName: "Charms", webpackPrefetch: true */ './components/Charm')
);

export const CharmSelector = React.forwardRef(
    (props: CharmSelectorProps, ref?: React.RefObject<any>) => (
        <Suspense fallback={null}>
            <LazyCharmSelector {...props} ref={ref} />
        </Suspense>
    )
);

export const CharmControl = React.forwardRef(
    (props: CharmControlProps, ref?: React.RefObject<any>) => (
        <Suspense fallback={null}>
            <LazyCharmControl {...props} ref={ref} />
        </Suspense>
    )
);

export const Charm = React.forwardRef((props: CharmProps, ref?: React.RefObject<any>) => (
    <Suspense fallback={null}>
        <LazyCharm {...props} ref={ref} />
    </Suspense>
));

export const lazyGetCharmsStore = new LazyAction(lazyModule, m => m.getCharmsStore);
